import { render, staticRenderFns } from "./appShop.vue?vue&type=template&id=696de006&"
import script from "./appShop.vue?vue&type=script&lang=js&"
export * from "./appShop.vue?vue&type=script&lang=js&"
import style0 from "./appShop.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports